/**
 * Cookie Manager
 * Handles setting and getting cookies for the application.
 */

export const cookieManager = {
    /**
     * Set a cookie
     * @param name Name of the cookie
     * @param value Value of the cookie
     * @param days Number of days until expiration (optional)
     * @param domain Domain to set the cookie on (optional)
     */
    set: (name: string, value: string, days?: number, domain?: string) => {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }

        let domainStr = "";
        if (domain) {
            domainStr = "; domain=" + domain;
        }

        document.cookie = `${name}=${value}${expires}${domainStr}; path=/; SameSite=Lax; Secure`;
    },

    /**
     * Clear a cookie by name from the current hostname
     * This is useful to prevent domain-level conflicts (e.g. api.domain vs .domain)
     */
    clearCurrent: (name: string) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
        // Also try clearing with the exact hostname just in case
        if (typeof window !== "undefined") {
            const hostname = window.location.hostname;
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${hostname}`;
        }
    },

    /**
     * Get a cookie by name
     * @param name Name of the cookie
     * @returns Value of the cookie or null if not found
     */
    get: (name: string): string | null => {
        const nameEQ = name + "=";
        const ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

    /**
     * Remove a cookie by name
     * @param name Name of the cookie
     * @param domain Domain the cookie was set on (optional)
     */
    remove: (name: string, domain?: string) => {
        cookieManager.set(name, "", -1, domain);
    },
};
